var exports = {
  "tb": "UserProfileModal.module__noteTextarea___bS1kdW",
  "CR": "UserProfileModal.module__modalRoot___bS1kdW",
  "ft": "UserProfileModal.module__modalRootFramed___bS1kdW",
  "eF": "UserProfileModal.module__userInfo___bS1kdW",
  "hR": "UserProfileModal.module__userInfoHeader___bS1kdW",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___bS1kdW",
  "Rn": "UserProfileModal.module__userInfoContent___bS1kdW",
  "yn": "UserProfileModal.module__profileDataWarning___bS1kdW",
  "S7": "UserProfileModal.module__nameRow___bS1kdW",
  "nT": "UserProfileModal.module__userName___bS1kdW",
  "a1": "UserProfileModal.module__userTag___bS1kdW",
  "Fj": "UserProfileModal.module__usernameRow___bS1kdW",
  "hI": "UserProfileModal.module__pronouns___bS1kdW",
  "sM": "UserProfileModal.module__srOnly___bS1kdW",
  "Li": "UserProfileModal.module__customStatusText___bS1kdW",
  "Ef": "UserProfileModal.module__customStatusRow___bS1kdW",
  "_z": "UserProfileModal.module__tagBadgeRow___bS1kdW",
  "U3": "UserProfileModal.module__badgesWrapper___bS1kdW",
  "ZV": "UserProfileModal.module__userNoteEditor___bS1kdW",
  "xu": "UserProfileModal.module__noteLabel___bS1kdW",
  "_j": "UserProfileModal.module__noteTextareaBase___bS1kdW",
  "jd": "UserProfileModal.module__noteTextareaEditing___bS1kdW",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___bS1kdW",
  "bs": "UserProfileModal.module__profileContent___bS1kdW",
  "EM": "UserProfileModal.module__profileContentHeader___bS1kdW",
  "cI": "UserProfileModal.module__bannerContainer___bS1kdW",
  "HG": "UserProfileModal.module__bannerMask___bS1kdW",
  "_e": "UserProfileModal.module__bannerImage___bS1kdW",
  "N1": "UserProfileModal.module__headerContainer___bS1kdW",
  "H": "UserProfileModal.module__avatarContainer___bS1kdW",
  "fc": "UserProfileModal.module__actionButtonsContainer___bS1kdW",
  "hQ": "UserProfileModal.module__contentContainer___bS1kdW",
  "sq": "UserProfileModal.module__profileContentWrapper___bS1kdW",
  "zL": "UserProfileModal.module__scrollerFullHeight___bS1kdW",
  "jT": "UserProfileModal.module__modalContainer___bS1kdW",
  "uu": "UserProfileModal.module__actionButtons___bS1kdW",
  "iA": "UserProfileModal.module__buttonIcon___bS1kdW",
  "ro": "UserProfileModal.module__menuIcon___bS1kdW",
  "WB": "UserProfileModal.module__avatarFocusRing___bS1kdW",
  "VS": "UserProfileModal.module__tabsWrapper___bS1kdW",
  "OT": "UserProfileModal.module__mutualFriendsList___bS1kdW",
  "Z8": "UserProfileModal.module__mutualSectionDivider___bS1kdW",
  "KF": "UserProfileModal.module__mutualFriendItem___bS1kdW",
  "vu": "UserProfileModal.module__active___bS1kdW",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___bS1kdW",
  "D9": "UserProfileModal.module__mutualFriendInfo___bS1kdW",
  "eV": "UserProfileModal.module__mutualFriendName___bS1kdW",
  "zD": "UserProfileModal.module__mutualFriendUsername___bS1kdW",
  "p$": "UserProfileModal.module__emptyState___bS1kdW",
  "Ny": "UserProfileModal.module__mutualGuildIcon___bS1kdW",
  "me": "UserProfileModal.module__separator___bS1kdW",
  "AI": "UserProfileModal.module__emptyStateIcon___bS1kdW",
};

module.exports = exports;
